import { VirtualMirror } from '@luxottica/virtual-mirror'
import { useEffect } from 'react'
import { useEan, useEanUpdate } from './context/eanContext'
import { extractEans } from './helpers/extractEans'

const initOptions = {
  key: '92f28486-6ca0-46cf-9b66-fec8224ddc72', // shared by VM team, if you have only the SSH key, open a ticket
  brand: 'e-wholesale', // to be defined with Luxottica's Analytics team
  storeId: 'optique', // to be defined with Luxottica's Analytics team
  channel: 'wholesale', // to be defined with Luxottica's Analytics team
  locale: 'en-US',

  // below parameters are optional, please contact Luxottica to understand if are required
  storeRegion: '',
  storeCompany: '',
  globalStoreId: '',
}

const initParams = {
  options: initOptions,
}

const Mirror = () => {
  const eans = useEan()
  const updateEans = useEanUpdate()

  const eanHolders = window.parent.document.querySelectorAll('.ean-holder')
  const startVmButtons =
    window.parent.document.querySelectorAll('.startVmButton')
  const exitVmButtons = window.parent.document.querySelectorAll('.exitVmButton')
  const newLocalization = VirtualMirror.getMirrorDefaultLocalization()
  const actuallyStartVmButton = window.parent.document.querySelector('.startVm')

  const vmBtnContainer = window.parent.document.querySelector('.vm_buttons')

  const changeGuidance = (obj, category) => {
    if (!obj) return
    for (let key in obj) {
      newLocalization[category][key] = obj[key]
    }
    VirtualMirror.overrideLocalization(newLocalization)
  }

  const handleChangeLang = () => {
    // if (window.parent.app_shop.vars.guidance) {
    //   changeGuidance(window.parent.app_shop.vars.guidance, 'GUIDANCE')
    // }
    //
    // if (window.parent.app_shop.vars.generic_error) {
    //   changeGuidance(window.parent.app_shop.vars.generic_error, 'GENERIC_ERROR')
    // }
    //
    // if (window.parent.app_shop.vars.manual_start) {
    //   changeGuidance(window.parent.app_shop.vars.manual_start, 'MANUAL_START')
    // }
    //
    // if (window.parent.app_shop.vars.permission_error) {
    //   changeGuidance(
    //     window.parent.app_shop.vars.permission_error,
    //     'PERMISSION_ERROR'
    //   )
    // }
    //
    // if (window.parent.app_shop.vars.ui) {
    //   changeGuidance(window.parent.app_shop.vars.ui, 'UI')
    // }
    //
    // if (window.parent.app_shop.vars.webcam_error) {
    //   changeGuidance(window.parent.app_shop.vars.webcam_error, 'WEBCAM_ERROR')
    // }
  }

  useEffect(() => {
    if (window.parent.document.readyState !== 'loading') {
      handleChangeLang()
    } else {
      window.parent.document.addEventListener('DOMContentLoaded', () => {
        handleChangeLang()
      })
    }

    async function initEans() {
      if (!eanHolders) return
      await extractEans(eanHolders, updateEans)
    }
    initEans()
  }, [])

  const startVm = (e) => {
    e.preventDefault()
    VirtualMirror.initialize(initParams)
      .then(() => {
        const renderParams = {
          target: 'target-mirror',
          upc: eans[0].ean,
          options: {}
        }

        return VirtualMirror.renderMirror(renderParams)
      })
      .then(() => {
        window.parent.document
          .querySelector('iframe[title="virtualMachine"]')
          .classList.add('running')

        window.parent.document
          .querySelector('.virtualMachine_wrapper')
          .classList.add('running')

        startVmButtons.forEach((btn) => {
          btn.classList.add('hidden')
        })
        exitVmButtons.forEach((btn) => {
          btn.classList.add('shown')
        })
      })
      .catch((error) => {
        alert(error);
        console.error(error)
      })
  }

  const exitVm = (e) => {
    e.preventDefault()
    VirtualMirror.closeMirror({
      target: 'target-mirror',
    })
    exitVmButtons.forEach((btn) => {
      btn.classList.remove('shown')
    })
    startVmButtons.forEach((btn) => {
      btn.classList.remove('hidden')
    })
    window.parent.document
      .querySelector('iframe[title="virtualMachine"]')
      .classList.remove('running')

    window.parent.document
      .querySelector('.virtualMachine_wrapper')
      .classList.remove('running')
  }

  if (eans.filter((e) => e.isAvailable).length > 0) {
    if (vmBtnContainer) {
      vmBtnContainer.classList.add('available')
    }
    ;[...startVmButtons].forEach((btn) => {
      btn.style.display = 'block'
    })
  }

  if (actuallyStartVmButton && eans.length > 0) {
    // Select the node that will be observed for mutations
    const targetNode = window.parent.document.querySelector('body')

    // Options for the observer (which mutations to observe)
    const config = { attributes: true }

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      if (targetNode.className.includes('dialog_open')) {
        const actuallyStartVmButtonNew =
          window.parent.document.querySelector('.startVm')
        if (actuallyStartVmButtonNew) {
          actuallyStartVmButtonNew.onclick = startVm
        }
      }
    }

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback)

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config)
  }

  if (exitVmButtons.length > 0) {
    ;[...exitVmButtons].forEach((btn) => {
      btn.onclick = exitVm
    })
  }

  const changeGlasses = (ean) => {
    VirtualMirror.renderMirror({
      target: 'target-mirror',
      upc: ean,
    })
  }

  return (
    <>
      {eans.length > 0 ? (
        <>
          <div id="target-mirror" className="target-mirror"></div>

          {eans.length > 1 ? (
            <>
              <div className="versions_btn_container">
                {eans.map((ean, index) => {
                  return (
                    <button
                      className={
                        !ean.isAvailable ? 'ean-btn disabled' : 'ean-btn'
                      }
                      key={index}
                      onClick={() => {
                        changeGlasses(ean.ean)
                      }}
                      data-ean={ean.ean}
                    >
                      {ean.ean}
                    </button>
                  )
                })}
              </div>
            </>
          ) : (
            ''
          )}
          <button
            onClick={() => VirtualMirror.fitMeBetter()}
            className="fitMeBetter"
          >
            {VirtualMirror.getMirrorDefaultLocalization().UI.FIT_ME_BETTER}
          </button>
        </>
      ) : (
        ''
      )}
    </>
  )
}
export default Mirror
